module.exports = __webpack_public_path__ + "static/img/applet_test.aa14994b.png";